import {
    balanceSvg,
    billSvg,
    bloodSugarSvg,
    bonesSvg,
    cardioSvg,
    cellsSvg,
    concentrationSvg,
    energySvg,
    energyTestimonialSvg,
    fertilitySvg,
    fitTestimonialSvg,
    glassSvg,
    hormoneSvg,
    immuneSvg,
    immuneTestimonialSvg,
    innerPeaceSvg,
    metabolismSvg,
    shippingSvg,
    skinSvg,
    skinTestimonialSvg,
    thyroidSvg,
    usp1Svg,
    usp2Svg,
    usp3Svg,
    usp4Svg,
    vitalitySvg
} from "../../../types/svgs"

import React from "react"
import { cn } from "../../../shared/utils/cn"

export type IconName =
    | "balance"
    | "bloodSugar"
    | "bones"
    | "cardio"
    | "cells"
    | "concentration"
    | "energy"
    | "fertility"
    | "hormone"
    | "immune"
    | "innerPeace"
    | "metabolism"
    | "skin"
    | "thyroid"
    | "vitality"
    | "usp1"
    | "usp2"
    | "usp3"
    | "usp4"
    | "bill"
    | "glass"
    | "shipping"
    | "skinTestimonial"
    | "fitTestimonial"
    | "energyTestimonial"
    | "immuneTestimonial"

interface IconProps {
    icon: IconName
    className?: string
}

const SvgIcon = ({ icon, className }: IconProps) => {
    const icons = {
        balance: balanceSvg,
        bloodSugar: bloodSugarSvg,
        bones: bonesSvg,
        cardio: cardioSvg,
        cells: cellsSvg,
        concentration: concentrationSvg,
        energy: energySvg,
        fertility: fertilitySvg,
        hormone: hormoneSvg,
        immune: immuneSvg,
        innerPeace: innerPeaceSvg,
        metabolism: metabolismSvg,
        skin: skinSvg,
        thyroid: thyroidSvg,
        vitality: vitalitySvg,
        usp1: usp1Svg,
        usp2: usp2Svg,
        usp3: usp3Svg,
        usp4: usp4Svg,
        bill: billSvg,
        glass: glassSvg,
        shipping: shippingSvg,
        skinTestimonial: skinTestimonialSvg,
        fitTestimonial: fitTestimonialSvg,
        energyTestimonial: energyTestimonialSvg,
        immuneTestimonial: immuneTestimonialSvg,
    }

    return (
        <span className={cn("block", className)}>
            {React.cloneElement(icons[icon] || <></>, { className: "block h-auto w-full" })}
        </span>
    )
}

export default React.memo(SvgIcon)
